import {batch, computed, signal} from "@preact/signals-react";
import {errors} from "@signals";
import {DATE_METRICS} from "@constants";


export const PriceEvolutionShowListPrice = signal(true)
export const PriceEvolutionCurrentTabData = signal({})
export const PriceEvolutionShowMinMax = signal(null)
export const PriceEvolutionTabsTableID = signal(null)
export const PriceEvolutionChartMetric = signal(DATE_METRICS.DAILY)
export const PriceEvolutionIsEmpty = signal(false)

// Computed
export const PriceEvolutionCurrentTabId = computed(() => PriceEvolutionCurrentTabData.value.id)
export const PriceEvolutionCurrentTabLabel = computed(() => PriceEvolutionCurrentTabData.value.label)

export const resetRetailerPriceEvolutionFilters = () => batch(() => {
	PriceEvolutionShowListPrice.value = true
	PriceEvolutionCurrentTabData.value = {}
	PriceEvolutionShowMinMax.value = null
	PriceEvolutionTabsTableID.value = null
	errors.value = {}
})